module.exports = __webpack_public_path__ + "static/media/meyvn-horizontal.1308e641.png";